import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PosterSession from "./PosterSession";
import Configuration from "./Configuration";

import fetch from "node-fetch";
import "./App.css";
import "react-awesome-lightbox/build/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NewApplication from "./new-application";
import { API_URL, CONF, SESSIONS } from "./config";
import AllSessions from "./AllSessions";
import Presentation from "./presentation";

function App() {
  const [postersConfig, setPostersConfig] = useState({});

  useEffect(() => {
    const fetchContentConfig = async () => {
      const response = await fetch(`${API_URL}/content?conf=${CONF}`);
      if (response.status < 300) {
        const json = await response.json();
        const sessionsArray = SESSIONS.split(",");
        const keysToRemove = Object.keys(json.themes).filter(
          (x) => !sessionsArray.includes(x)
        );

        keysToRemove.forEach((k) => delete json.themes[k]);

        setPostersConfig(json);
      } else {
        console.warn(
          "Brak zdefiniowanej konfiguracji dla plakatów. Skontatkuj się z administratorem."
        );
      }
    };

    fetchContentConfig();
  }, []);

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/allSessions">
            <AllSessions config={postersConfig} />
          </Route>
          <Route exact path="/presentation">
            <Presentation config={postersConfig} />
          </Route>
          <Route exact path="/sessions/:sessionId/posters/:posterId">
            <PosterSession config={postersConfig} />
          </Route>
          <Route exact path="/sessions/:sessionId">
            <PosterSession config={postersConfig} />
          </Route>
          <Route path="/config">
            <Configuration />
          </Route>
          <Route path="/new-application/:posterId?">
            <NewApplication />
          </Route>
          <Route path="/">
            <div className="sessions-list">
              <div className="sessions">
                <AllSessions config={postersConfig} />
              </div>
            </div>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
